// Le scelte della Dashboard di chi la guarda: quali widget vedere e cosa mostra il grafico dei
// progetti. Stanno nel browser; se lo spazio non c'è (finestra privata) valgono i default.
import { useCallback, useState } from 'react';

export const WIDGETS = [
  { id: 'waiting', label: 'Aspettano te' },
  { id: 'schedule', label: 'Pianifica' },
  { id: 'projects', label: 'Progetti' },
  { id: 'people', label: 'Chi sta facendo cosa' },
  { id: 'usage', label: 'Consumi' },
  { id: 'health', label: 'Salute' },
  { id: 'recent', label: 'Ultime sessioni' },
] as const;
export type WidgetId = (typeof WIDGETS)[number]['id'];
export type Metric = 'tokens' | 'cost';
export type Period = 7 | 14 | 30;

export interface DashboardPrefs {
  hidden: WidgetId[];
  metric: Metric;
  period: Period;
}

const KEY = 'poptown.dashboard';
const DEFAULTS: DashboardPrefs = { hidden: [], metric: 'tokens', period: 14 };

function read(): DashboardPrefs {
  try {
    const raw = localStorage.getItem(KEY);
    return raw ? { ...DEFAULTS, ...(JSON.parse(raw) as Partial<DashboardPrefs>) } : DEFAULTS;
  } catch {
    return DEFAULTS;
  }
}

export function useDashboardPrefs() {
  const [prefs, setPrefs] = useState<DashboardPrefs>(read);
  const update = useCallback((patch: Partial<DashboardPrefs>) => {
    setPrefs((p) => {
      const next = { ...p, ...patch };
      try {
        localStorage.setItem(KEY, JSON.stringify(next));
      } catch {
        // niente spazio nel browser: la scelta vale finché la pagina resta aperta
      }
      return next;
    });
  }, []);
  return { prefs, update };
}
